import { FC } from 'react'
import { Transition, TransitionStatus } from 'react-transition-group'
import { IconButton } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import { rightSideBarStyle } from './RightSideBar.style'
import { RootState } from '../../Store'
import { maxSidebarWidth, sidebarAnimationDuration, rightSidebarWidth as sidebarWidth } from '../../Constants'
import { useDispatch, useSelector } from 'react-redux'
import { InfoView } from '../../reducers/InfoMenuReducer'
import { BoreholeInfo } from '../boreholeinfo/BoreholeInfo'
import { infoMenuActions } from 'src/actions/InfoMenuActions'
import { VirtualBoreholeInfo } from '../virtualboreholeinfo/VirtualBoreholeInfo'
import { Rnd } from 'react-rnd'
import { generalActions } from 'src/actions/GeneralActions'
import { getBarStyle, getBarTransitionStyle } from 'src/utils/Utils'

export interface RightSideBarProps { } // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: RightSideBarProps = {}

/**
 * RightSideBar React component.
 * @param {object} props React properties object.
 * @returns React view component.
 */
export const RightSideBar: FC<RightSideBarProps> = (
  props: RightSideBarProps
) => {
  const dispatch = useDispatch()
  const classes = rightSideBarStyle()
  const currentView = useSelector((state: RootState): InfoView => state.infoMenuState.currentView)
  const dragging = useSelector((state: RootState): Boolean => state.generalState.rightSideBarDragging)
  const rightSideBarWidth = useSelector((state: RootState): number => state.generalState.rightSideBarWidth)

  const sidebarStyle = getBarStyle(dragging === true ? 0 : sidebarAnimationDuration)
  const sidebarTransitionStyles = getBarTransitionStyle(rightSideBarWidth)

  /**
   * Set to empty view when close button is clicked.
   */
  const closeSideBarClicked = (): void => {
    dispatch(infoMenuActions.currentView(InfoView.Empty))
  }

  return (
    <>
      <Transition in={currentView !== InfoView.Empty} timeout={0}>
        {(state: TransitionStatus) => (
          <>
            {currentView !== InfoView.Empty && (
              <div
                className={`${classes.root}`}
                style={{ ...sidebarStyle, ...sidebarTransitionStyles[state] }}
              >
                <Rnd
                  disableDragging
                  enableResizing={{ left: true }}
                  position={{ x: 0, y: 0 }}
                  size={{ width: rightSideBarWidth, height: 'auto' }}
                  minWidth={sidebarWidth}
                  maxWidth={maxSidebarWidth}
                  onResizeStart={() => {
                    dispatch(generalActions.setRightSideBarDragging(true))
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    dispatch(generalActions.setRightSideBarWidth(parseInt(ref.style.width)))
                  }}
                  onResizeStop={(e, direction, ref, delta, position) => {
                    dispatch(generalActions.setRightSideBarWidth(parseInt(ref.style.width)))
                    dispatch(generalActions.setRightSideBarDragging(false))
                  }}
                >
                  {dragging === false && (
                    <div className={classes.root}>
                      {currentView === InfoView.BoreholeInfo && (
                        <BoreholeInfo />
                      )}
                      {currentView === InfoView.VirtualBoreholeInfo && (
                        <VirtualBoreholeInfo />
                      )}
                      <div className={classes.closeButton}>
                        <IconButton size='medium' className={classes.closeButtonIcon} onClick={closeSideBarClicked}>
                          <Close />
                        </IconButton>
                      </div>
                    </div>
                  )}
                </Rnd>
              </div>
            )}
          </>
        )}
      </Transition>
    </>
  )
}

RightSideBar.defaultProps = defaultProps

export default RightSideBar
